"use strict";

import {withTheme} from '@rjsf/core';

const Form = withTheme({name: "default"});
var React = require("react");
var ReactDOM = require("react-dom");
var CreateReactClass = require("create-react-class");

var ReactChildComponent = CreateReactClass({
    getInitialState: function () {
        
        var _this = this;
        this.props.store.store.subscribe(function () {
            // tslint:disable-next-line:no-shadowed-variable
            var storeState = _this.props.store.store.getState();
            // tslint:disable-next-line:no-shadowed-variable
            var formKey = _this.props.formKey;
            var formData = storeState.FormData == null ? null : JSON.parse(JSON.stringify(storeState.FormData));
            _this.setState({
                schema: storeState.Schema,
                uiSchema: JSON.parse(JSON.stringify(storeState.UiSchema)),
                formData: formData,
                key: formKey
            });
        });
        var storeState = this.props.store.store.getState();
        var formKey = this.props.formKey;
        return {
            schema: storeState.Schema,
            uiSchema: storeState.UiSchema,
            formData: storeState.FormData,
            key: formKey
        };
    },
    render: function () {
        var _this = this;
        var schema = this.state.schema;
        var uiSchema = this.state.uiSchema;
        var formData = this.state.formData;
        var key = this.state.key;
        var onSubmit = function (form) {
            var storeState = _this.props.store.store.getState();
            storeState.FormData = form.formData;
            storeState.FormDataHasErrors = false;
            var currentState = {
                schema: storeState.Schema,
                uiSchema: JSON.parse(JSON.stringify(storeState.UiSchema)),
                formData: formData,
                key: Date.now()
            };
            _this.setState(currentState);
            if (_this.props.submitCallback) {
                _this.props.submitCallback();
            }
            return false;
        };
        var transformErrors = function (errors) {
            if (errors != null && errors.length > 0) {
                var storeState = _this.props.store.store.getState();
                storeState.FormData = null;
                storeState.FormDataHasErrors = true;
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < errors.length; i++) {
                    if (errors[i].name === 'required') {
                        errors[i].message = 'Requires property  ' + errors[i].schema.properties[errors[i].argument].title;
                    }
                }
            }
            return errors;
        };
        return (React.createElement("div", null,
            React.createElement(Form, { 
                key: key, 
                schema: schema, 
                uiSchema: uiSchema, 
                formData: formData, 
                onSubmit: onSubmit, 
                showErrorList: false, 
                transformErrors: transformErrors, 
                id: 'form-' + this.props.templateId 
            })
        ));
    }
});
export const ReactChildComponentView = /** @class */ (function () {
    // tslint:disable-next-line:no-shadowed-variable , no-empty
    function ReactChildComponentView() { }
    ReactChildComponentView.initialize = function (store, containerId, injector, formKey, submitCallback) {
        if (formKey === void 0) { formKey = Date.now(); }
        // tslint:disable-next-line:no-empty
        if (submitCallback === void 0) { submitCallback = function () { }; }
        ReactDOM.hydrate(React.createElement(ReactChildComponent, { templateId: containerId, store: store, injector: injector, formKey: formKey, submitCallback: submitCallback }), document.getElementById(containerId));
    };
    return ReactChildComponentView;
}());
